import { Routes } from '@angular/router';

// All applications routes.
import { AuthGuard } from '@root/shared/guards/auth.guard';
import { LayoutComponent } from 'src/shared/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent, // LAYOUT SIDE MENU
    canActivate: [AuthGuard],
    children: [{ path: '', redirectTo: '/apps', pathMatch: 'full' }],
  },
  {
    path: 'apps',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@apps/utils/config/module').then((m) => m.AppsListModule),
  },
  {
    path: 'cart',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@applications/cart/utils/cart.routes').then(
        (m) => m.cartRoutes,
      ),
  },
  {
    path: 'cgu',
    loadComponent: () =>
      import('@shared/pages/cgu/cgu.component').then((m) => m.CguComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('@login/views/register/register.component').then(
        (m) => m.RegisterComponent,
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('@login/utils/config/module').then((m) => m.LoginModule),
  },
  {
    path: '403',
    loadComponent: () =>
      import('@shared/forbidden/forbidden.component').then(
        (m) => m.ForbiddenComponent,
      ),
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];
